import script from "./TermsAndPolicies.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndPolicies.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndPolicies.vue?vue&type=style&index=0&id=59b5bf9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b5bf9a"]])

export default __exports__